import { Suspense } from 'react';
import { ReactElement } from 'react';

import LoadingSpinner from 'components/LoadingSpinner';

import { RouteObject } from 'types/route';

import { AppModules } from 'constants/enums';

export const createRoute = (
  path: string,
  key: string,
  element: ReactElement,
  protectedRoute: boolean = false,
  module: AppModules | null,
  breadcrumb?: string,
  children: RouteObject[] = [],
  isFullHeightSpinner: boolean = false,
  isPageSpinner: boolean = true
): RouteObject => ({
  path,
  key,
  protectedRoute,
  element: (
    <Suspense
      fallback={
        <LoadingSpinner
          isFullHeight={isFullHeightSpinner}
          isPageSpinner={isPageSpinner}
        />
      }
    >
      {element}
    </Suspense>
  ),
  module,
  breadcrumb,
  children
});
